function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/* eslint-disable no-plusplus, max-len */
import get from 'lodash/get';
import map from 'lodash/map';
export var FormatterPattern =
/*#__PURE__*/
function () {
  function FormatterPattern(patternStr) {
    _classCallCheck(this, FormatterPattern);

    this.pattern = map(patternStr, function (char) {
      var test;
      var delimiter = false;

      switch (char) {
        case 'a':
          test = function test(val) {
            return /[A-Za-z]/.test(val);
          };

          break;

        case '9':
          test = function test(val) {
            return /[0-9]/.test(val);
          };

          break;

        case 'x':
          test = function test(val) {
            return /[A-Za-z0-9]/.test(val);
          };

          break;

        default:
          delimiter = true;

          test = function test(val) {
            return char === val;
          };

          break;
      }

      return {
        char: char,
        test: test,
        delimiter: delimiter
      };
    });
  }

  _createClass(FormatterPattern, [{
    key: "getItem",
    value: function getItem(caret) {
      return this.pattern[caret];
    } // process value into pattern, or extract raw value from patterned value

  }, {
    key: "processValue",
    value: function processValue(val) {
      var raw = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var chars = '';
      var item;
      var char;
      var trailingDelimiters = 0;
      var patternIdx = 0;
      var valIdx = 0; // now step through each character of the value and the pattern

      while (valIdx < val.length) {
        char = val[valIdx]; // current character in value

        item = this.getItem(patternIdx); // what character should be in the pattern

        if (item === undefined) {
          // index in val is greater than total length of pattern
          break;
        } else if (raw && item.delimiter) {
          // raw extraction: removing expected delimiters
          if (item.test(char)) {
            // current char is expected delimiter
            valIdx++; // step to next char in value
          }

          patternIdx++; // always step to next char in pattern
        } else if (item.test(char)) {
          // raw and patterned: is current character valid in the pattern?
          chars += char; // add current char to output

          trailingDelimiters = item.delimiter ? trailingDelimiters + 1 : 0; // keep track of trailing delimiters.  reset when not delimiter

          patternIdx++; // step to next char in pattern

          valIdx++; // step to next char in value
        } else if (item.delimiter) {
          // current idx in pattern is delimiter char
          chars += item.char; // add the matching delimiter to output

          trailingDelimiters++;
          patternIdx++; // step to next char in pattern
        } else {
          // current char in value is invalid
          valIdx++; // step to next char in value
        }
      }

      chars = chars.slice(0, chars.length - trailingDelimiters); // remove trailing delimiters from pattern format

      return chars;
    } // format a string to a pattern

  }, {
    key: "format",
    value: function format(val) {
      return this.processValue(val, false);
    } // return the raw value from a formatted pattern string

  }, {
    key: "extract",
    value: function extract(val) {
      return this.processValue(val, true);
    }
  }, {
    key: "isDelimiterPosition",
    value: function isDelimiterPosition(idx) {
      return get(this.getItem(idx), 'delimiter', false);
    }
  }, {
    key: "isFollowingDelimiter",
    value: function isFollowingDelimiter(idx) {
      return this.isDelimiterPosition(idx - 1);
    }
  }]);

  return FormatterPattern;
}(); // pattern:
//  '9' is numeral
//  'a' is alpha
//  'x' is all (alphanumeric?)
//  any other character is a delimiter in the pattern

export default function formatPatternFactory(patternStr) {
  var pattern = new FormatterPattern(patternStr);

  function formatPattern(input) {
    var caret = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var prevState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (!input.value.length) {
      // nothing written, don't allow eager printing
      // of potential delimiter characters at start of pattern
      return {
        formattedValue: '',
        maskedValue: '',
        value: '',
        returnCaret: 0
      };
    }

    var prevLength = get(prevState, 'formattedValue', '').length;
    var prevValue = get(prevState, 'value', '');
    var value = pattern.extract(input.value); // raw value

    var formattedValue = pattern.format(input.value); // convert input value to pattern

    var returnCaret = caret; // eagerly add trailing delimiter as indicator

    while (pattern.isDelimiterPosition(formattedValue.length)) {
      var delimiterChar = pattern.getItem(formattedValue.length).char;
      formattedValue = "".concat(formattedValue).concat(delimiterChar);
    } // -- time to position the caret --
    // determine the amount of delimiters added with this entry


    var inputBeforeCaret = input.value.slice(0, caret);
    var formattedValueBeforeCaret = pattern.format(inputBeforeCaret);
    returnCaret += formattedValueBeforeCaret.length - inputBeforeCaret.length; // add that amount to the returnCaret

    if (formattedValue.length > prevLength) {
      // user added char(s)
      while (pattern.isDelimiterPosition(returnCaret)) {
        // multiple delimiters can exist in a row. follow them forward
        returnCaret += 1; // move the caret past delimiters
      }
    } else if (formattedValue.length < prevLength) {
      // user deleted char(s)
      while (pattern.isFollowingDelimiter(returnCaret)) {
        // user deleted char after delimiter. multiple delimiters can exist in a row. follow them back
        returnCaret -= 1; // move caret back before the delimiters
      }

      if (value === '') {
        // allow user to delete eagerly printed delimiters at beginning of pattern
        formattedValue = '';
      }
    } // were invalid or delimiter characters were scrubbed/deleted ?


    if (input.value.length > formattedValue.length && value.length === prevValue.length) {
      while (pattern.isDelimiterPosition(returnCaret)) {
        // multiple delimiters can exist in a row. follow them forward
        // test the item in pattern vs the character in the original inputted value
        var item = pattern.getItem(returnCaret);

        if (!item.test(input.value[returnCaret])) {
          break; // was not the right character.  char was scrubbed, do not advance
        }

        returnCaret += 1; // inputted character was the delimiter character. advance
      }
    }

    return {
      formattedValue: formattedValue,
      value: value,
      returnCaret: returnCaret
    };
  } // expose the FormatterPattern in this scope
  //  TODO: remove this when formatDate overrides
  //        are resolved in next major version (^9)


  formatPattern.pattern = pattern;
  return formatPattern;
}